<template>
  <div>
    <Head :title="`Comment creatd by ${comment.user.first_name} ${comment.user.last_name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/comments">Comments</Link>
      <span class="text-indigo-400 font-medium">/</span>
      Comment created by {{ comment.user.first_name }} {{ comment.user.last_name }}
    </h1>
    <trashed-message v-if="comment.deleted_at" class="mb-6" @restore="restore"> This comment has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.rate" :error="form.errors.rate" class="pb-8 pr-6 w-full lg:w-1/2" label="Rate 1-5" />
          <textarea-input v-model="form.content" :error="form.errors.content" class="pb-8 pr-6 w-full lg:w-1/2" label="Content" rows="5" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Comment</button>
          <div class="ml-auto flex items-center bg-gray-50 border-t border-gray-100">
            <Link class="text-blue-600 hover:underline mr-2" tabindex="-1" href="/comments">Go back</Link>
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Update Comment</loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from "@/Shared/TextareaInput.vue";

export default {
  components: {
    TextareaInput,
    Head,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    comment: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        content: this.comment.content,
        rate: this.comment.rate,
        recording_id: this.comment.recording_id,
        user_id: this.comment.user_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/comments/${this.comment.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this comment?')) {
        this.$inertia.delete(`/contacts/${this.comment.id}`)
      }
    },
  },
}
</script>
